import genericField from './components/generic_field_component'
import genericForm from './components/generic_form_component'

angular
  .module('bzFormModule', [])
  .component('genericForm', genericForm)
  .component('genericField', genericField)
